var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpcoes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2143_3468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 3.75C7.8125 4.95812 8.79188 5.9375 10 5.9375C11.2081 5.9375 12.1875 4.95812 12.1875 3.75C12.1875 2.54188 11.2081 1.5625 10 1.5625C8.79188 1.5625 7.8125 2.54188 7.8125 3.75Z",
    fill: "#4D4F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 10.3125C7.8125 11.5206 8.79188 12.5 10 12.5C11.2081 12.5 12.1875 11.5206 12.1875 10.3125C12.1875 9.10438 11.2081 8.125 10 8.125C8.79188 8.125 7.8125 9.10438 7.8125 10.3125Z",
    fill: "#4D4F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 16.875C7.8125 18.0831 8.79188 19.0625 10 19.0625C11.2081 19.0625 12.1875 18.0831 12.1875 16.875C12.1875 15.6669 11.2081 14.6875 10 14.6875C8.79188 14.6875 7.8125 15.6669 7.8125 16.875Z",
    fill: "#4D4F50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2143_3468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpcoes);
export default __webpack_public_path__ + "static/media/opcoes.8a9e16bcc0e66b27f77284fdcb573fbf.svg";
export { ForwardRef as ReactComponent };